const IDENTITY_KEY = "chin:identity:v1";

/**
 * Clave secreta anónima del dispositivo: identifica al jugador en el ranking
 * sin registro. El servidor solo conoce su hash SHA-256.
 */
export function deviceKey(): string | null {
  try {
    let key = localStorage.getItem(IDENTITY_KEY);
    if (!key) {
      key = `${crypto.randomUUID()}${crypto.randomUUID()}`;
      localStorage.setItem(IDENTITY_KEY, key);
    }
    return key;
  } catch {
    return null;
  }
}

/** Hash público de la identidad, para consultar la posición propia en el ranking. */
export async function deviceKeyHash(): Promise<string | null> {
  const key = deviceKey();
  if (!key || !crypto.subtle) return null;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(key));
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, "0")).join("");
}
